// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"styles_modalBody__106h0","error":"styles_error__36NgT"};